var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHumidifier = function SvgHumidifier(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "svg110",
    width: 354,
    height: 354,
    fillRule: "evenodd",
    clipRule: "evenodd",
    imageRendering: "optimizeQuality",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    viewBox: "0 0 354 354",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1247",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M59.727 278.94c82.627-10.472 159.9-11.186 242.52-.12-3.095 23.325-13.692 55.455-29.765 64.023-12.977 6.902-72.388 3.689-91.557 3.689-18.335 0-78.103 2.737-90.366-3.213-16.192-7.854-28.336-40.936-30.836-64.38zm-1.429-11.186c-2.143-57.001 26.788-91.274 41.433-137.8 55.958 7.973 110.13 8.211 162.52-.12 13.454 44.864 44.766 82.945 41.314 137.801-18.93-.952-39.766-4.522-59.53-5.95-43.219-2.856-84.294-2.856-127.51.238-19.169 1.428-39.766 4.879-58.22 5.831zm47.624-147.92c1.072-6.188 6.191-17.017 8.81-23.205 4.406-10.71 3.453-16.66 14.764-16.66h102.15c12.263 0 11.43 6.664 16.073 17.731 2.262 5.593 8.453 17.493 7.858 22.848-49.886 8.211-99.772 7.378-149.66-.714zm73.341 40.103c3.453 1.666 13.692 15.827 16.668 20.349 10.24 16.184 21.193 36.057 7.858 53.907-21.312 28.084-64.173 5.355-53.577-29.274 2.977-9.401 7.858-17.493 12.382-24.633 2.858-4.522 13.216-18.683 16.668-20.349z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path1249",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M183.31 25.943c10.715-16.779.476-23.562-5.953-14.875-10.596 14.28-6.072 19.278-1.071 27.132-10.834 16.66-.596 23.443 5.833 14.756 1.786-2.261 6.192-10.472 6.549-13.566.595-6.545-3.215-10.234-5.358-13.447"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "path1251",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M140.33 25.943c10.596-16.779.476-23.562-5.953-14.875-10.596 14.28-6.191 19.278-1.071 27.132-10.953 16.66-.596 23.443 5.833 14.756 1.667-2.261 6.192-10.472 6.43-13.566.595-6.545-3.096-10.234-5.239-13.447"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "path1253",
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M226.29 25.943c10.715-16.779.595-23.562-5.953-14.875-1.667 2.261-6.191 10.353-6.43 13.566-.595 6.664 3.096 10.115 5.358 13.566-10.834 16.66-.476 23.443 5.953 14.756 1.667-2.261 6.191-10.472 6.43-13.566.595-6.545-3.215-10.234-5.358-13.447z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHumidifier);
export default ForwardRef;